export default "__VITE_ASSET__KGihV9La__"